import axios from "axios";
import axiosInstance from "../utils/axios";

const mmlApiKey = "9396425f-0fe1-4631-adc9-a3f6621fcbcb";

export const getPropertiesFromBbox = async (sw: any, ne: any) => {
  //const url = `https://avoin-paikkatieto.maanmittauslaitos.fi/kiinteisto-avoin/simple-features/v3/collections/PalstanSijaintitiedot/items?filter=S_INTERSECTS(geometry,POINT(565448.001%206992568.973))&filter-crs=http://www.opengis.net/def/crs/EPSG/0/3067&filter-lang=cql2-text`;

  const urlBbox = `https://avoin-paikkatieto.maanmittauslaitos.fi/kiinteisto-avoin/simple-features/v3/collections/KiinteistorajanSijaintitiedot/items?bbox=${sw.E},${sw.N},${ne.E},${ne.N}&bbox-crs=http://www.opengis.net/def/crs/EPSG/0/3067&crs=http://www.opengis.net/def/crs/EPSG/0/3067&api-key=${mmlApiKey}`;

  const properties = await axios.get(urlBbox);
  return properties;
};

//Koordinaattipisteet alemmassa "väärin päin", jotta pystyisi poimimaan tietoja. Tarkista, onko tarpeen pitää alempaa
export const getPropertyFromLonLat = async (lat: any, lon: any) => {
  const url = `https://avoin-paikkatieto.maanmittauslaitos.fi/kiinteisto-avoin/simple-features/v3/collections/PalstanSijaintitiedot/items?filter=S_INTERSECTS(geometry,POINT(${lon}%20${lat}))&filter-crs=http://www.opengis.net/def/crs/EPSG/0/3067&filter-lang=cql2-text&api-key=${mmlApiKey}`;

  const property = await axios.get(url);
  return property;
};

export const getPropertyFromLatLon = async (lat: any, lon: any) => {
  const url = `https://avoin-paikkatieto.maanmittauslaitos.fi/kiinteisto-avoin/simple-features/v3/collections/PalstanSijaintitiedot/items?filter=S_INTERSECTS(geometry,POINT(${lat}%20${lon}))&filter-crs=http://www.opengis.net/def/crs/EPSG/0/3067&filter-lang=cql2-text&api-key=${mmlApiKey}`;

  const property = await axios.get(url);
  return property;
};

export const getPropertyName = async (
  easting: number,
  northing: number
): Promise<string | null> => {
  try {
    const response = await axiosInstance.get(
      `/properties/name?lon=${easting}&lat=${northing}`
    );
    return response.data?.name ?? null;
  } catch {
    return null;
  }
};
